// Preview builds a fresh in-memory graph on the server, so we strip `id`
// (which would cause RecordNotFound on the new graph) and filter out
// `_destroy` records (which only matter when updating existing records).
function cleanNestedAttributes(attributes) {
  return attributes
    .filter((attr) => !attr._destroy)
    .map(({ id: _id, ...rest }) => rest)
}

export default function buildPreviewParams(formattedGraph) {
  return {
    ...formattedGraph,
    reportGraph: {
      ...formattedGraph.reportGraph,
      reportGraphValuesAttributes: cleanNestedAttributes(
        formattedGraph.reportGraph.reportGraphValuesAttributes
      ),
      reportGraphPeriodsAttributes: cleanNestedAttributes(
        formattedGraph.reportGraph.reportGraphPeriodsAttributes
      ),
    },
  }
}
